import { Avatar, Flex } from 'antd'
import React, { ReactNode } from 'react'

type Props = {
  children: ReactNode[]
}

export const IconGroup: React.FC<Props> = ({ children }) => {
  return (
    <>
      <Avatar.Group>
        {children.map((child, index) => (
          <Flex key={index}>{child}</Flex>
        ))}
      </Avatar.Group>
    </>
  )
}
